import { toast } from '@/helpers/toast/toast.helper'
import { AxiosResponse } from 'axios'
import { put } from 'redux-saga/effects'
import { promoteAdminGroupAction } from '../../handles'
import { zApiMultiService } from '@/services/api'
import { promoteAdmin } from '../_http/groups'

export function* promoteAdminGroupSaga(action: ReturnType<typeof promoteAdminGroupAction.request>) {
  const { activeChat, phones, campaign, callBack } = action.payload
  try {
    const url = `/instances/campanhaId/${campaign.id}/token/${campaign.token}/add-admin`
    const promoteAdminGroupResponse: AxiosResponse = yield zApiMultiService.post(url, {
      groupId: activeChat.phone,
      phones
    })

    if (promoteAdminGroupResponse.data?.value) {
      const { participants } = activeChat
      const findedParticipant = participants.find(participant => participant.phone === phones[0])
      if (findedParticipant) {
        findedParticipant.isAdmin = true
      }
      yield promoteAdmin(activeChat.id, phones[0], activeChat.ownerId)

      toast({ type: 'success', message: `Contato promovido para administrador` })
      yield put(promoteAdminGroupAction.success({ updatedChatData: { participants } }))
      callBack?.()
    } else {
      toast({ type: 'error', message: 'Não foi possível promover contato, tente novamente' })
      yield put(promoteAdminGroupAction.failure(null))
    }
  } catch (error) {
    toast({ type: 'error', message: 'Erro ao promover contato' })
    console.log({ promoteAdminGroupSagaError: error })
    yield put(promoteAdminGroupAction.failure(error))
  }
}
